import { render, staticRenderFns } from "./Alert.vue?vue&type=template&id=4a0e61a6&scoped=true&lang=pug"
import script from "./Alert.vue?vue&type=script&lang=js"
export * from "./Alert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0e61a6",
  null
  
)

export default component.exports